module.exports = __webpack_public_path__ + "02d9c1d207cf0d3d49c5c0081809ac3f.png";